<template>
  <div>
    <CRow class="d-flex justify-content-start align-items-center px-3">
      <p>
        {{ $t("role.data.profileImages.modal.intro") }}
      </p>
    </CRow>

    <CRow class="d-flex justify-content-start align-items-center">
      <CButtonGroup class="ml-3 mb-3">
        <CButton
          color="primary"
          :variant="filterType === null ? '' : 'outline'"
          id="all"
          @click="toggleActive(null)"
          >{{ $t("role.profile.tab_images.filter_type.all") }}</CButton
        >
        <CButton
          color="primary"
          :variant="filterType === filterOption.value ? '' : 'outline'"
          :id="filterOption.value"
          :key="filterOption.value"
          v-for="filterOption in filterOptions"
          @click="toggleActive(filterOption.value)"
          >{{ filterOption.label }}</CButton
        >
      </CButtonGroup>
    </CRow>
    <CRow v-if="paginatedImages !== null" class="px-2 py-4 mb-4 bg-light">
      <CCol
        sm="6"
        md="3"
        lg="3"
        xl="2"
        class="mb-4 d-flex justify-content-center align-items-center"
      >
        <CButton
          class="btn-upload w-100 h-100 bg-white"
          @click="onOpen(null)"
          style="aspect-ratio: 1 / 1"
        >
          <font-awesome-icon icon="camera" size="2x" />
          {{ $t("role.profile.tab_logos.addPhoto") }}</CButton
        >
      </CCol>
      <CCol
        sm="6"
        md="3"
        lg="3"
        xl="2"
        v-for="(image, index) in paginatedImages"
        :key="index"
        class="mb-4"
        @click="onOpen(image)"
      >
        <ProfileImagesImageNew
          :image="image"
          :roleId="role"
          :filterStatus="filterType"
          @refresh="UpdateImages"
        />
      </CCol>
    </CRow>
    <div v-else class="loading">
      <CSpinner color="secondary" size="lg" />
    </div>
    <CRow v-if="numPages > 1">
      <CCol md="12">
        <CPagination
          :active-page.sync="currentPage"
          :pages="numPages"
          responsive
        />
      </CCol>
    </CRow>

    <CModal
      v-if="showCropModal"
      title="Foto hinzufügen"
      :show.sync="showCropModal"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CInputCheckbox
        v-for="(option, optionIndex) in filterOptions"
        :key="optionIndex"
        :label="option.label"
        :value="option.value"
        :checked="uploadType[option.value]"
        @change="uploadType[option.value] = !uploadType[option.value]"
        :options="filterOptions"
        inline
        class="mb-3"
      />
      <form
        v-if="previewUrl === null"
        class="dropzone"
        :class="{ 'dropzone--is-dragover': isDragover }"
        method="post"
        enctype="multipart/form-data"
        @dragover.stop.prevent="isDragover = true"
        @dragenter.stop.prevent="isDragover = true"
        @dragleave.stop.prevent="isDragover = false"
        @dragend.stop.prevent="isDragover = false"
        @drop.stop.prevent="onDrop"
      >
        <div class="dropzone__input">
          <input
            class="dropzone__file"
            type="file"
            ref="uplaodFile"
            id="uplaodFile"
            @change="onFileChange"
            accept="image/png, image/gif, image/jpeg"
          />
          <label v-if="!loading" @click="onLabelClick">
            <font-awesome-icon icon="camera" />
            <br />
            {{ $t("role.profile.tab_logos.photoUpload.selectPhoto") }} <br />
            <span class="dropzone__dragndrop">
              {{ $t("role.profile.tab_logos.photoUpload.dropPhoto") }}</span
            >
          </label>
        </div>
        <div v-if="loading" class="dropzone__uploading">
          {{ $t("role.profile.tab_logos.photoUpload.loading") }}
        </div>
        <div v-if="errors" class="dropzone__error">{{ errors }}</div>
      </form>

      <cropper
        v-if="showPreview"
        ref="cropper"
        class="cropper"
        :src="previewUrl"
        :stencil-props="stencilProps"
        @change="onCropperChange"
        @ready="onCropperReady"
      ></cropper>
      <template #footer>
        <CButton color="primary" variant="ghost" @click="onReplace">{{
          $t("role.profile.tab_logos.photoUpload.replacePhoto")
        }}</CButton>

        <CButton color="primary" variant="outline" @click="onCancel">{{
          $t("common.editor.button.cancel")
        }}</CButton>

        <vue-ladda
          :disabled="
            uploadType.gallery === false &&
            uploadType.slideshow === false &&
            uploadType.background === false
          "
          :loading="saving"
          data-style="zoom-in"
          button-class="btn btn-primary"
          @click="onSave"
          >{{ $t("common.editor.button.save") }}</vue-ladda
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import ProfileImagesImageNew from "./ProfileImagesImageNew";
import { apiGet, apiPost, apiPatch } from "../../../helpers/apiHelper";
import { Cropper } from "vue-advanced-cropper";
import { apiUrl } from "../../../http";
import { decodeCoordinates, prepareCoordinates } from "../../../helpers/common";
const loadImage = require("blueimp-load-image");

const ratioEnum = Object.freeze({
  "300:155": 300 / 155,
  "1:1": 1,
  free: null,
});

export default {
  data() {
    const aspectRatio = ratioEnum[this.ratio] || null;
    return {
      loading: false,
      saving: false,
      errors: "",
      isDragover: false,
      stencilProps: { aspectRatio },
      file: null,
      previewUrl: null,
      showCropModal: false,
      coordinates: null,
      imageData: null,
      ratio: "free",

      currentPage: 1,
      numPages: 1,
      itemsPerPage: 17,
      images: null,
      filteredImages: null,

      image_new: null,
      image_loading: false,
      role: this.$store.state.role.id,

      filterType: null,
      filterOptions: [
        {
          value: "gallery",
          label: this.$t("role.profile.tab_images.filter_type.gallery"),
        },
        {
          value: "slideshow",
          label: this.$t("role.profile.tab_images.filter_type.slideshow"),
        },
        {
          value: "background",
          label: this.$t("role.profile.tab_images.filter_type.background"),
        },
      ],
      uploadType: {
        gallery: false,
        slideshow: false,
        background: false,
      },
    };
  },
  computed: {
    showPreview: function () {
      return this.previewUrl !== null;
    },
    thumbnail() {
      if (this.image) {
        return this.image.image_thumb;
      }
      return null;
    },
    cropping() {
      if (this.imageData) {
        return decodeCoordinates(this.imageData.image_cropping);
      }
      return null;
    },

    height() {
      return 111;
    },

    width() {
      return this.stencilProps.aspectRatio !== null
        ? this.height * this.stencilProps.aspectRatio
        : 148;
    },

    paginatedImages() {
      if (!this.filteredImages) return null;
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredImages.slice(start, end);
    },
  },

  components: {
    ProfileImagesImageNew,
    Cropper,
  },

  methods: {
    original(image) {
      if (image) {
        return image.image.img;
      }
      return null;
    },

    checkType(value) {
      if (this.uploadType?.[value] === true) {
        this.uploadType[value] = false;
        return false;
      } else {
        this.uploadType[value] = true;
        return true;
      }
    },

    toggleActive(value) {
      this.filterType = value;
      this.currentPage = 1;
      this.filterImages();
    },

    filterImages() {
      if (this.filterType === null) {
        this.filteredImages = this.images;
      } else {
        this.filteredImages = this.images.filter(
          (image) => image.image?.[this.filterType] === true
        );
      }
      this.updatePagination();
    },

    updatePagination() {
      if (this.filteredImages) {
        this.numPages = Math.ceil(
          this.filteredImages.length / this.itemsPerPage
        );
        if (this.currentPage > this.numPages && this.numPages > 0) {
          this.currentPage = this.numPages;
        }
      }
    },

    onLabelClick() {
      this.$refs.uplaodFile.click();
    },

    UpdateImages() {
      let self = this;
      self.images = null;
      self.filteredImages = null;
      const response = apiGet("role_imagecrop", [this.$store.state.role.id]);
      response
        .then((res) => {
          self.images = res.data.payload.Items.filter(
            (item) =>
              item.image.gallery === true ||
              item.image.slideshow === true ||
              item.image.background === true
          );
          self.filteredImages = res.data.payload.Items.filter(
            (item) =>
              item.image.gallery === true ||
              item.image.slideshow === true ||
              item.image.background === true
          );
          self.updatePagination();
        })
        .catch((res) => {
          console.error("Failed to fetch images:", res);
        });
    },

    onOpen(image) {
      if (this.original(image) !== null) {
        this.previewUrl = this.original(image);
      }
      if (image !== null) {
        this.imageData = image;
        // Load current uploadType values from image
        this.uploadType.gallery = image.image.gallery || false;
        this.uploadType.slideshow = image.image.slideshow || false;
        this.uploadType.background = image.image.background || false;
      } else {
        // Reset uploadType for new upload
        this.uploadType.gallery = false;
        this.uploadType.slideshow = false;
        this.uploadType.background = false;
      }
      this.saving = false;
      this.showCropModal = true;
    },

    onFileChange(e) {
      const self = this;
      this.file = e.target.files[0];
      self.upload(this.file);
    },

    onCropperChange({ coordinates }) {
      this.coordinates = coordinates;
    },

    onCropperReady() {
      if (this.cropping && this.$refs.cropper) {
        this.$refs.cropper.setCoordinates({ ...this.cropping });
      }
    },

    onReplace() {
      this.file = this.previewUrl = null;
    },

    onCancel() {
      if (this.file === null) {
        this.showCropModal = false;
        return;
      }
      this.file = this.previewUrl = null;
    },

    onDrop(e) {
      this.isDragover = false;
      this.file = e.dataTransfer.files[0];
      this.upload(this.file);
    },

    onSave() {
      this.saving = true;
      this.saveImageCropping()
        .then((payload) => {
          const updatePayload = {
            gallery: this.uploadType.gallery,
            slideshow: this.uploadType.slideshow,
            background: this.uploadType.background,
          };
          return apiPatch(
            "role_image",
            this.imageData.image.id,
            updatePayload,
            [this.$store.state.role.id]
          );
        })
        .then((response) => {
          this.saving = false;
          this.showCropModal = false;
          this.UpdateImages();
          this.$emit("onSave", {
            imageData: this.imageData,
            coordinates: this.coordinates,
          });
          this.imageData = null;
          this.errors = "";
          this.file = null;
          this.previewUrl = null;
          this.coordinates = null;
        })
        .catch((response) => {
          console.error(response);
          this.saving = false;
        });
    },

    saveImageCropping() {
      if (!this.imageData || !this.coordinates) {
        return Promise.reject(new Error("missing required params"));
      }

      const formData = {
        image: this.imageData.image.id,
        image_cropping: prepareCoordinates(this.coordinates),
        image_ratio: this.ratio,
      };

      // If imageData has an id, update existing crop, otherwise create new
      if (this.imageData.id) {
        return apiPatch("role_imagecrop", this.imageData.id, formData, [
          this.$store.state.role.id,
        ]).then((response) => {
          return response.data.payload;
        });
      } else {
        return apiPost("role_imagecrop", formData, [
          this.$store.state.role.id,
        ]).then((response) => {
          return response.data.payload;
        });
      }
    },

    upload(file) {
      const self = this;
      const url = apiUrl(`/api/role/${this.$store.state.role.id}/image/`);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      const options = {
        maxWidth: 1920,
        maxHeight: 1920,
        meta: true,
        canvas: true,
      };

      loadImage(file, options)
        .then(function (data) {
          return new Promise(function (resolve) {
            data.image.toBlob(function (blob) {
              resolve(new File([blob], "filename.jpeg"));
            }, "image/jpeg");
          });
        })
        .then(function (data) {
          const formData = new FormData();
          formData.append("img", data);
          formData.append("img", data);
          formData.append("gallery", self.uploadType.gallery);
          formData.append("slideshow", self.uploadType.slideshow);
          formData.append("background", self.uploadType.background);
          self.loading = true;
          self.errors = "";
          return self.axios
            .post(url, formData, config)
            .then((response) => {
              self.loading = false;
              const { payload } = response.data;
              self.previewUrl = payload.img;
              // Fetch the imagecrop record to get the id
              return apiGet("role_imagecrop", [self.$store.state.role.id]).then(
                (cropResponse) => {
                  // Find the crop record for this image
                  const imageCrop = cropResponse.data.payload.Items.find(
                    (item) => item.image.id === payload.id
                  );
                  if (imageCrop) {
                    self.imageData = imageCrop;
                  } else {
                    self.imageData = { image: payload };
                  }
                  return response;
                }
              );
            })
            .catch((error) => {
              console.log(error.response.data);
              self.errors = "Errore sul caricamento dell'immagine";
            })
            .finally(() => {
              self.loading = false;
            });
        })
        .catch(function (err) {
          self.errors = err.toString();
        });
    },
  },
  created() {
    this.UpdateImages();
  },
};
</script>
